export const BASKET_PREFIX = '@BASKET';
